// Shared score-prediction value used by the bet UIs (BetSheet on mobile,
// BetDialog on desktop) and the submit helper (betSubmit).
export type ModalValue = {
  homeScore: number | null;
  awayScore: number | null;
};

export const initModalValue: ModalValue = {
  homeScore: null,
  awayScore: null,
};
